// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kTahSQ9{display:flex;justify-content:flex-start;align-items:center;margin-bottom:1em;padding:.75em;border-radius:.313em;background:var(--gray-and-white-graphite-sber-4, #f6f7fa)}@media(max-width: 599px){.kTahSQ9{margin-bottom:.5em}}.CvSOnVZ{padding-left:.75em;font-size:14px;text-align:center;text-align:left;color:var(--gray-and-white-graphite-sber-1, #576875)}@media(min-width: 600px){.CvSOnVZ{margin-bottom:0}}.CvSOnVZ p{font-size:14px;color:var(--gray-and-white-graphite-sber-1, #576875)}.BoEEnR5{display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `kTahSQ9`,
	"text": `CvSOnVZ`,
	"icon": `BoEEnR5`
};
export default ___CSS_LOADER_EXPORT___;
